gsap.registerPlugin(ScrollTrigger)

let lenis;

export const initSmoothScroll = () => {

	const wrapperEl = document.querySelector('#sn-page');
	const wrapperCont = document.querySelector('#sn-page > *');

	lenis = new Lenis({
		wrapper:  wrapperEl,  
		content: wrapperCont, 
		
		smooth: true,
		lerp: 0.03, // más bajo = más suave/lento
		// lerp: 0.05, // más bajo = más suave/lento
		direction: 'vertical',
		gestureDirection: 'vertical',
		normalizeWheel: true,
		smoothTouch: false,

		// prevent: (node) => node.id === "modal"
	})

	// Sync con ScrollTrigger
	lenis.on('scroll', ScrollTrigger.update)

	const raf = (time) => {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf)
}

export const getLenis = () => lenis